import { UpdatesConfig } from "@urql/exchange-graphcache";

import { GetAssetView } from "../../features/asset/queries.graphql";
import { GetForgeInferences } from "../../features/forge/queries.graphql";
import {
  isInference as isInference,
  isWorkspace,
  TypedObject,
} from "../../utils/graphql";
import { InferenceEdge } from "./schema.graphql";

const updatesConfig: Partial<UpdatesConfig> = {
  Mutation: {
    generateImages: ({ generateImages }, _args, cache) => {
      const resp = generateImages as TypedObject;
      if (isInference(resp)) {
        // update workspace style inferences, if possible
        if (resp.workspace?.name) {
          cache.updateQuery(
            {
              query: GetForgeInferences,
              variables: {
                workspaceName: resp.workspace.name,
              },
            },
            (data) => {
              if (data !== null) {
                if (isWorkspace(data.workspace)) {
                  data.workspace.inferences?.edges?.unshift?.({
                    __typename: "InferenceEdge",
                    node: resp as InferenceEdge["node"],
                    cursor: "[new]", // Revisit: caching a stateful cursor is likely not the best idea
                  });
                }
                return data;
              } else {
                return null;
              }
            },
          );
          // update asset style inferences, if possible
          if (resp.asset?.id) {
            cache.updateQuery(
              {
                query: GetAssetView,
                variables: {
                  workspaceName: resp.workspace.name,
                  assetId: resp.asset.id,
                },
              },
              (data) => {
                if (data !== null) {
                  if (isWorkspace(data.workspace)) {
                    data.workspace.asset?.inferences?.edges?.unshift?.({
                      __typename: "InferenceEdge",
                      node: resp as InferenceEdge["node"],
                      cursor: "[new]", // Revisit: caching a stateful cursor is likely not the best idea
                    });
                  }
                  return data;
                } else {
                  return null;
                }
              },
            );
          }
        }
      }
    },
  },
};

export default updatesConfig;
